import { z } from 'zod';

export const membershipRegisterMaxPage = 100_000;
export const membershipRegisterSortValues = [
  'membershipNumber.asc',
  'membershipNumber.desc',
  'startDate.asc',
  'startDate.desc',
  'expirationDate.asc',
  'expirationDate.desc',
  'status.asc',
  'status.desc',
] as const;
export type MembershipRegisterSort = (typeof membershipRegisterSortValues)[number];
export type MembershipRegisterSortKey =
  | 'membershipNumber'
  | 'startDate'
  | 'expirationDate'
  | 'status';
export const membershipRegisterDefaultSort = 'startDate.desc' as const;

const optionalTrimmedText = z
  .string()
  .trim()
  .transform((value) => (value.length === 0 ? undefined : value))
  .optional();

export const membershipRegisterSearchSchema = z
  .object({
    membershipDateFrom: z.iso.date().optional(),
    membershipDateTo: z.iso.date().optional(),
    membershipInstructorId: z.uuid().optional(),
    membershipOwnerId: z.uuid().optional(),
    membershipPage: z.coerce.number().int().positive().max(membershipRegisterMaxPage).optional(),
    membershipQ: optionalTrimmedText.pipe(z.string().max(100).optional()),
    membershipSort: z.enum(membershipRegisterSortValues).optional(),
    membershipStatus: optionalTrimmedText.pipe(z.string().max(100).optional()),
    membershipTypeId: z.uuid().optional(),
  })
  .strip();

export type MembershipRegisterSearch = z.infer<typeof membershipRegisterSearchSchema>;

export function normalizeMembershipRegisterSearch(search: unknown): MembershipRegisterSearch {
  return membershipRegisterSearchSchema.parse(search);
}

/** Drops Membership-detail and Documents state when navigating back to the global register. */
export function projectMembershipRegisterSearch(
  search: Partial<MembershipRegisterSearch>
): MembershipRegisterSearch {
  return membershipRegisterSearchSchema.parse(search);
}
